import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverig = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Overig_svg__a)">
      <mask
        id="Overig_svg__b"
        width={28}
        height={10}
        x={6}
        y={15}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M20 15a5 5 0 1 1 0 10 5 5 0 0 1 0-10M6 20a3 3 0 1 0 6 0 3 3 0 0 0-6 0m22 0a3 3 0 1 0 5.999 0A3 3 0 0 0 28 20"
        />
      </mask>
      <g mask="url(#Overig_svg__b)">
        <path
          fill="#F7A941"
          d="m-11.98 17.68 7.07-12.25L7.34 12.5z"
        />
        <path
          fill="#F18700"
          d="m7.34 12.5 12.25 7.07-7.07 12.25zM31.84 26.64l-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="m26.66 7.32-7.07 12.25L7.34 12.5z"
        />
        <path
          fill="#F7A941"
          d="m12.52 31.82 7.07-12.25 12.25 7.07zM12.52 31.82.27 24.75 7.34 12.5zM7.34 12.5.27 24.75l-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="M-6.8 36.99.27 24.75l12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m26.66 7.32 12.25 7.07-7.07 12.25zM31.84 26.64l7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m51.16 21.46-7.07 12.25-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Overig_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverig);

export default ForwardRef;
